export default __webpack_public_path__ + "static/media/bg.33d4ee88.png";